module.exports = __webpack_public_path__ + "img/onboarding_clean.84c6e5c9.png";